import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint) => apiCall("delete", endpoint);

export const submitProjectAPI = async (body) => {
  try {
    return await post("project", body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const updateStageApi = async (id, bodyData) => {
  try {
    return await put(`project/stage/${id}`, bodyData);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const updateProjectAPI = async (id, body) => {
  try {
    return await put(`project/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const updateProductAPI = async (id, body) => {
  try {
    return await put(`project/product/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getProjectListApi = async (params) => {
  try {
    return await get("project", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getProjectEditApi = async (id) => {
  try {
    return await get(`project/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getProjectExpenseApi = async (id, revisionId) => {
  try {
    return await post(`report/project_expense/${id}`, {
      revision_id: revisionId,
    });
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getProjectViewApi = async (id) => {
  try {
    return await get(`project/view/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getProjectEditdApi = async (id) => {
  try {
    return await get(`project/product/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getTransDetailsApi = async (productId, projectId) => {
  try {
    return await get(`project/transactions/${productId}`, {
      project_id: projectId,
    });
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const deleteProjectApi = async (id) => {
  try {
    return await del(`project/delete/${id}`);
  } catch (err) {
    return err.response;
  }
};

export const getBudgetApi = async (id, search) => {
  try {
    return await get(`project/budget/${id}`, { search });
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getProjectStageApi = async () => {
  try {
    return await get("get_project_stage");
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const addBudgetApi = async (id, body) => {
  try {
    return await put(`project/budget/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
